export const SET_SURFBOARD = 'SET_SURFBOARD';
export const CLEAR_SURFBOARD = 'CLEAR_SURFBOARD';
